// Lightweight zero-dep password strength scorer. Returns { score: 0-4, label, hint }.
// Scoring philosophy: reward length + character variety, penalize the obvious
// common passwords. We keep it fast so it can run on every keystroke.

const COMMON = new Set([
  "password", "password1", "password123", "123456", "12345678", "qwerty",
  "letmein", "welcome", "admin", "iloveyou", "abc123", "monkey", "dragon",
  "lectura", "student", "school",
]);

const LABELS = ["Too weak", "Weak", "Okay", "Strong", "Excellent"];
const HINTS = [
  "Add more characters or mix letters, numbers & symbols.",
  "Try 10+ chars with a mix of letters, numbers & symbols.",
  "Great — add a symbol or number to bump it up.",
  "Strong. You can submit.",
  "Bulletproof. Nice.",
];

export function scorePassword(pw) {
  const s = pw || "";
  if (!s) return { score: 0, label: "", hint: "" };
  if (COMMON.has(s.toLowerCase())) return { score: 0, label: LABELS[0], hint: "That's a very common password — pick something else." };

  let score = 0;
  if (s.length >= 8) score += 1;
  if (s.length >= 12) score += 1;
  const classes = [/[a-z]/.test(s), /[A-Z]/.test(s), /\d/.test(s), /[^A-Za-z0-9]/.test(s)].filter(Boolean).length;
  if (classes >= 2) score += 1;
  if (classes >= 3) score += 1;

  // Cap and floor
  score = Math.max(0, Math.min(4, score));
  return { score, label: LABELS[score], hint: HINTS[score] };
}
